export default {
    takeaway : {
        response: {},
        designs : {
            backgroundColor: "rgb(240, 244, 248)",
            textColor : "rgb(16, 42, 67)",
            title: "TABLE OF CONTENTS",
            alignment: "float-left"
        }
    }
}